import { NgModule } from '@angular/core';

import { SharedModule }     from '../../shared/shared.module';
import { WebSocketService } from './websocket.service';

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    WebSocketService
  ]
})
export class WebsocketsModule {}